import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  FiChevronRight,
  FiShield,
  FiCheckCircle,
  FiDatabase,
  FiMail,
  FiUser,
  FiInfo,
  FiFileText,
  FiTag,
  FiUsers,
  FiPhone,
} from 'react-icons/fi';
import '../../styles/categoryPage.css';
import './Politique.css';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const Politique = () => {
  return (
    <div className="hd-policy-container">
      <div className="container">
        <motion.nav
          className="hd-breadcrumb"
          aria-label="breadcrumb"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <Link to="/">Accueil</Link>
          <FiChevronRight />
          <span>Politique de confidentialité</span>
        </motion.nav>
      </div>

      <div className="hd-policy-hero">
        <div className="hd-policy-hero-content">
          <span className="hd-policy-eyebrow">Vos données, protégées</span>
          <h1 className="hd-policy-title">Politique de confidentialité</h1>
          <p className="hd-policy-subtitle">Home Deco - Protection de vos données personnelles</p>
        </div>
      </div>

      <div className="hd-policy-content">
        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiShield /></span>
            <h2>Introduction</h2>
          </div>
          <p>
            Chez Home Deco, accessible depuis <a href="https://Home-Deco.tn/">https://Home-Deco.tn/</a>,
            la protection de la vie privée de nos visiteurs est l'une de nos principales priorités.
            Ce document de politique de confidentialité contient les types d'informations collectées et enregistrées par Home Deco, ainsi que la manière dont nous les utilisons.
          </p>
          <p>
            Si vous avez des questions supplémentaires ou avez besoin de plus d'informations sur notre politique de confidentialité, n'hésitez pas à <a href="mailto:votre@gmail.com">nous contacter</a>.
          </p>
          <p>
            Cette politique de confidentialité s'applique uniquement à nos activités en ligne et est valable pour les visiteurs de notre site web en ce qui concerne les informations qu'ils partagent et/ou collectent sur Home Deco.
          </p>
        </motion.section>

        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiCheckCircle /></span>
            <h2>Consentement</h2>
          </div>
          <p>
            En utilisant notre site web, vous consentez à notre politique de confidentialité et acceptez ses termes.
          </p>
        </motion.section>

        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiDatabase /></span>
            <h2>Informations que nous collectons</h2>
          </div>
          <p>
            Les informations personnelles que vous êtes invité à fournir, ainsi que les raisons pour lesquelles vous êtes invité à les fournir, vous seront clairement indiquées au moment où nous vous demanderons de fournir vos informations personnelles.
          </p>
          <div className="hd-policy-info-cards">
            <div className="hd-policy-info-card">
              <span className="hd-policy-info-card-icon"><FiMail /></span>
              <h3>Contact direct</h3>
              <p>Si vous nous contactez directement, nous pouvons recevoir des informations supplémentaires vous concernant (nom, email, téléphone, message).</p>
            </div>
            <div className="hd-policy-info-card">
              <span className="hd-policy-info-card-icon"><FiUser /></span>
              <h3>Création de compte</h3>
              <p>Lors de l'inscription, nous pouvons demander vos coordonnées complètes (nom, entreprise, adresse, email, téléphone).</p>
            </div>
          </div>
        </motion.section>

        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiInfo /></span>
            <h2>Utilisation de vos informations</h2>
          </div>
          <ul className="hd-policy-usage-list">
            <li>Fournir, exploiter et maintenir notre site web</li>
            <li>Améliorer, personnaliser et étendre notre site web</li>
            <li>Comprendre et analyser votre utilisation</li>
            <li>Développer de nouveaux produits et services</li>
            <li>Communiquer avec vous (service client, mises à jour)</li>
            <li>Vous envoyer des e-mails</li>
            <li>Détecter et prévenir la fraude</li>
          </ul>
        </motion.section>

        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiFileText /></span>
            <h2>Fichiers journaux</h2>
          </div>
          <p>
            Home Deco suit une procédure standard d'utilisation de fichiers journaux. Ces fichiers enregistrent les visiteurs lorsqu'ils consultent des sites web.
          </p>
          <div className="hd-policy-data-table">
            <div className="hd-policy-data-row">
              <span>Données collectées :</span>
              <span>Adresses IP, type de navigateur, FAI, date/heure, pages consultées</span>
            </div>
            <div className="hd-policy-data-row">
              <span>Utilisation :</span>
              <span>Analyser les tendances, administrer le site, suivre les mouvements des utilisateurs</span>
            </div>
          </div>
        </motion.section>

        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiTag /></span>
            <h2>Cookies et balises Web</h2>
          </div>
          <p>
            Comme tout autre site web, Home Deco utilise des "cookies" pour stocker des informations sur les préférences des visiteurs et les pages consultées.
          </p>
          <div className="hd-policy-notice">
            <div className="hd-policy-notice-icon">!</div>
            <p>
              <strong>Cookie Google DoubleClick DART :</strong> Google utilise des cookies pour diffuser des annonces en fonction de votre navigation. Vous pouvez refuser ces cookies via <a href="https://policies.google.com/technologies/ads">les paramètres de Google</a>.
            </p>
          </div>
        </motion.section>

        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiUsers /></span>
            <h2>Partenaires publicitaires</h2>
          </div>
          <p>
            Certains annonceurs sur notre site peuvent utiliser des cookies et des balises web. Voici nos principaux partenaires :
          </p>
          <div className="hd-policy-partner-card">
            <span className="hd-policy-partner-icon">G</span>
            <div>
              <h3>Google</h3>
              <a href="https://policies.google.com/technologies/ads">Politique de confidentialité de Google</a>
            </div>
          </div>
          <p className="hd-policy-small-text">
            Notez que Home Deco n'a pas accès ni contrôle sur les cookies utilisés par les annonceurs tiers.
          </p>
        </motion.section>

        <motion.section className="hd-policy-section" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.15 }} variants={fadeUp}>
          <div className="hd-policy-section-header">
            <span className="hd-policy-icon"><FiShield /></span>
            <h2>Vos droits</h2>
          </div>

          <div className="hd-policy-rights-tabs">
            <div className="hd-policy-rights-tab">
              <h3>Droits CCPA (Californie)</h3>
              <ul>
                <li>Demander la divulgation des données collectées</li>
                <li>Demander la suppression de vos données</li>
                <li>Demander à ne pas vendre vos données</li>
              </ul>
            </div>

            <div className="hd-policy-rights-tab">
              <h3>Droits RGPD (Europe)</h3>
              <ul>
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit d'opposition</li>
                <li>Droit à la portabilité</li>
              </ul>
            </div>
          </div>

          <div className="hd-policy-contact-box">
            <span className="hd-policy-contact-box-icon"><FiPhone /></span>
            <div>
              <p>Pour exercer vos droits ou pour toute question :</p>
              <a href="https://wa.me/21698403689" className="hd-policy-contact-button">Nous contacter</a>
            </div>
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default Politique;
